import { atom } from 'jotai';

import { EnvConfig } from '@config';

export enum FeatureFlagEnum {
  CmsBasedVerifyDetailsContent,
  ConsumerActivityLog,
  ConsumerAnchorSearch,
  ContractActions,
  ContractActivityLog,
  ContractPdf,
  PayByBank,
  TabSystem,
  Saves,
  TransactionActions,
  CsRequestRefund,
  SendLetterOfCancellation,
  SendPrrBreakdown,
  DeferredCallRedirect,
  Training,
  NewPermissionSystem,
  PostDateOnMissingDownPayment,
  CustomerOwnsVehicle,
  StopTransfer,
  ConsumerPageRedesign,
  NotesV2,
  EditSurchargesAndOptionsAfter30Days,
  DarkModeToggle,
}

export const FeatureFlagDisplayValue = {
  [FeatureFlagEnum.CmsBasedVerifyDetailsContent]: 'CMS Based Verify Details Content',
  [FeatureFlagEnum.ConsumerActivityLog]: 'Consumer Activity Log',
  [FeatureFlagEnum.ConsumerAnchorSearch]: 'Consumer Anchor Search',
  [FeatureFlagEnum.ContractActions]: 'Contract Actions',
  [FeatureFlagEnum.ContractActivityLog]: 'Contract Activity Log',
  [FeatureFlagEnum.ContractPdf]: 'Contract PDF link',
  [FeatureFlagEnum.PayByBank]: 'Pay by Bank',
  [FeatureFlagEnum.TabSystem]: 'Tab System',
  [FeatureFlagEnum.Saves]: 'Saves',
  [FeatureFlagEnum.TransactionActions]: 'Transaction Actions',
  [FeatureFlagEnum.CsRequestRefund]: 'CS Request Refund',
  [FeatureFlagEnum.SendLetterOfCancellation]: 'Send LoC Email',
  [FeatureFlagEnum.SendPrrBreakdown]: 'Send PRR Email',
  [FeatureFlagEnum.DeferredCallRedirect]: 'Deferred Call Redirect',
  [FeatureFlagEnum.Training]: 'Training',
  [FeatureFlagEnum.NewPermissionSystem]: 'Use New Permission System',
  [FeatureFlagEnum.PostDateOnMissingDownPayment]: 'Post Date On Missing Down Payment',
  [FeatureFlagEnum.CustomerOwnsVehicle]: 'Customer Owns Vehicle',
  [FeatureFlagEnum.StopTransfer]: 'Stop Transfer',
  [FeatureFlagEnum.ConsumerPageRedesign]: 'Consumer Page Redesign',
  [FeatureFlagEnum.NotesV2]: 'Notes V2',
  [FeatureFlagEnum.EditSurchargesAndOptionsAfter30Days]: 'Add Surcharge/Option >30',
  [FeatureFlagEnum.DarkModeToggle]: 'Dark Mode Toggle',
} satisfies Record<FeatureFlagEnum, string>;

export type TFeatureFlagState = Readonly<{
  featureFlags: FeatureFlagEnum[];
}>;

const INITIAL_FEATURE_STATE = {
  featureFlags: [
    FeatureFlagEnum.CmsBasedVerifyDetailsContent,
    FeatureFlagEnum.ConsumerAnchorSearch,
    FeatureFlagEnum.ContractActivityLog,
    FeatureFlagEnum.ContractActions,
    FeatureFlagEnum.ContractPdf,
    FeatureFlagEnum.CsRequestRefund,
    FeatureFlagEnum.Saves,
    FeatureFlagEnum.TransactionActions,
    FeatureFlagEnum.SendLetterOfCancellation,
    FeatureFlagEnum.SendPrrBreakdown,
    FeatureFlagEnum.NewPermissionSystem,
    FeatureFlagEnum.CustomerOwnsVehicle,
    FeatureFlagEnum.PostDateOnMissingDownPayment,
    FeatureFlagEnum.StopTransfer,
    EnvConfig.appEnv === 'qa' ? FeatureFlagEnum.Training : undefined,
  ].filter((flag) => flag != null),
} satisfies TFeatureFlagState;

const featureFlagAtom = atom<TFeatureFlagState>(INITIAL_FEATURE_STATE);

export { featureFlagAtom };
